export const getClassName = (menuId: string, selectedMenu: string) => {
  const className = "MenuItem";

  if (menuId === selectedMenu) return className + "--selectedMenu";

  return className;
};
